// test1594
(1594 && 0);
